<mat-card class="rounded-3xl border border-slate-200 p-6 shadow-sm">
  <h2 class="mb-1 text-lg font-semibold text-slate-900">The referral</h2>

  @if (!hasContent()) {
    <!-- Nothing is sent to a provider until it has accepted the case -->
    <p class="text-sm text-slate-500">The details of the referral are shown here once you have accepted the case.</p>
  } @else {
    <p class="mb-4 text-sm text-slate-500">What Momentum has told you of this case, to deliver the service. The goals are what the close-out report is written against.</p>

    <!-- Who the service is for and how to reach them -->
    @if (summary().member; as member) {
      <section class="mb-4">
        <h3 class="mb-2 text-sm font-semibold uppercase tracking-wide text-slate-500">Member</h3>
        <dl class="grid gap-x-6 gap-y-2 text-sm sm:grid-cols-2">
          <div>
            <dt class="text-slate-500">Name</dt>
            <dd class="font-medium text-slate-900">{{ member.name }}</dd>
          </div>
          @if (member.memberType) {
            <div>
              <dt class="text-slate-500">Member type</dt>
              <dd class="font-medium text-slate-900">{{ member.memberType }}</dd>
            </div>
          }
          <div>
            <dt class="text-slate-500">Mobile number</dt>
            <dd class="font-medium text-slate-900">{{ member.mobileNumber || 'Not recorded' }}</dd>
          </div>
          <div>
            <dt class="text-slate-500">Email address</dt>
            <dd class="font-medium text-slate-900">{{ member.emailAddress || 'Not recorded' }}</dd>
          </div>
          @if (member.customer) {
            <div>
              <dt class="text-slate-500">Customer</dt>
              <dd class="font-medium text-slate-900">{{ member.customer }}</dd>
            </div>
          }
        </dl>
      </section>
    }

    <!-- Why the member was referred, and how urgent it is -->
    <section class="mb-4">
      <h3 class="mb-2 text-sm font-semibold uppercase tracking-wide text-slate-500">Reason for the referral</h3>
      <dl class="grid gap-x-6 gap-y-2 text-sm sm:grid-cols-2">
        <div class="sm:col-span-2">
          <dt class="text-slate-500">Reason</dt>
          <dd class="font-medium text-slate-900">{{ summary().reason || 'Not recorded' }}</dd>
        </div>
        @if (summary().primaryProblem) {
          <div>
            <dt class="text-slate-500">Primary problem</dt>
            <dd class="font-medium text-slate-900">{{ summary().primaryProblem }}</dd>
          </div>
        }
        @if (summary().riskRating) {
          <div>
            <dt class="text-slate-500">Risk rating</dt>
            <dd class="font-medium text-slate-900">{{ summary().riskRating }}</dd>
          </div>
        }
      </dl>
    </section>

    @if (summary().presentingProblems.length > 0) {
      <section class="mb-4">
        <h3 class="mb-2 text-sm font-semibold uppercase tracking-wide text-slate-500">Presenting problems</h3>
        <ul class="list-disc pl-5 text-sm text-slate-900">
          @for (problem of summary().presentingProblems; track problem.id) {
            <li>{{ problem.description }}</li>
          }
        </ul>
      </section>
    }

    @if (summary().treatmentGoals.length > 0) {
      <section>
        <h3 class="mb-2 text-sm font-semibold uppercase tracking-wide text-slate-500">Treatment goals</h3>
        <ol class="list-decimal pl-5 text-sm text-slate-900">
          @for (goal of summary().treatmentGoals; track goal.id) {
            <li>{{ goal.goal }}</li>
          }
        </ol>
      </section>
    }
  }
</mat-card>
